import React, { useState, useEffect } from 'react'
import { Table, Icon, Panel } from 'rsuite'
import { budgetFormat } from '../../../utils/formatterUtil'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import TagCell from '../../../components/cell/TagCell'
import './styles.less'

export default function AssetSendBackEditListsTable({
  schema,
  loading,
  onReload = () => {},
  onSelect = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const [tableData, setTableData] = useState([])
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    // console.log('schema.values => ', schema.values)
    setTableData(schema.values)
  }, [schema.values])

  return (
    <>
      <div className="table-all-articles">
        <Table
          wordWrap
          minHeight={350}
          autoHeight
          loading={loading}
          headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
          data={tableData || []}
          style={{ marginTop: '20px' }}
          affixHeader
        >
          <Column width={100} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={250}>
            <HeaderCell>โครงการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return `${rowData.projectCode || ''}  ${rowData.projectName || ''}`
              }}
            </Cell>
          </Column>

          <Column width={160}>
            <HeaderCell>เลขที่ขอขึ้นทะเบียน</HeaderCell>
            <Cell dataKey="registerDocNo" />
          </Column>

          <Column width={160}>
            <HeaderCell>เลขที่ขอปิด</HeaderCell>
            <Cell dataKey="closureDocNo" />
          </Column>

          <Column width={180}>
            <HeaderCell>รหัสครุภัณฑ์</HeaderCell>
            {/* <Cell dataKey="assetCode" /> */}
            <Cell>
              {(rowData) => {
                return <b style={{ color: '#2da888' }}>{rowData.assetCode}</b>
              }}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>ชื่อครุภัณฑ์</HeaderCell>
            <Cell dataKey="assetName" />
          </Column>

          <Column width={160}>
            <HeaderCell>ประเภทครุภัณฑ์</HeaderCell>
            <Cell dataKey="assetType" />
          </Column>

          <Column width={180}>
            <HeaderCell>สถานะครุภัณฑ์</HeaderCell>
            {/* <Cell dataKey="assetStatus" /> */}
            <Cell>
              {(rowData) => {
                let _bgColor = ''
                let _color = '#ffffff'
                switch (rowData.assetStatusCode) {
                  case '0': //รอขึ้นทะเบียน
                  case '2': // เจ้าหน้าที่พัสดุออกเลขครุภัณฑ์
                  case '7': //นักวิชาการเสนอพิจารณาปิดครุภัณฑ์
                  case '9': // เจ้าหน้าที่พัสดุเสนอพิจารณาปิดครุภัณฑ์
                    _bgColor = '#5b9dfe' // น้ำเงิน
                    break

                  case '1': // ภาคีขอขึ้นทะเบียน
                  case '6': // ภาคีขอปิดครุภัณฑ์
                  case '12': // อนุมัติปิดครุภัณฑ์'
                  case '8': //ผอ.สำนักอนุมัติปิดครุภัณฑ์
                  case '3': // เจ้าหน้าที่พัสดุรับขึ้นทะเบียน
                    _bgColor = '#2da888' // เขียว
                    break

                  case '4': //เจ้าหน้าที่พัสดุส่งกลับแก้ไขขึ้นทะเบียน
                  case '10': // ส่งกลับแก้ไขปิดครุภัณฑ์
                  case '11': // ผอ. อำนวยการส่งกลับแก้ไขปิดครุภัณฑ์
                    _bgColor = '#EEB189' // ส้ม
                    break

                  case '5': // เจ้าหน้าที่พัสดุไม่รับขึ้นทะเบียน
                    _bgColor = '#fb8a81' //แดง
                    break

                  default:
                    _bgColor = '#f2f1f1'
                    _color = '#575757'
                    break
                }

                return (
                  <TagCell
                    dataKey="assetStatus"
                    rowData={rowData}
                    bgColor={_bgColor}
                    color={_color}
                  />
                )
                //return <p style={{ color: _color }}>{rowData.assetStatus}</p>
              }}
            </Cell>
          </Column>

          <Column width={160} align="right">
            <HeaderCell>ราคา</HeaderCell>
            {/* <Cell dataKey="totalPrice" /> */}
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.totalPrice)
              }}
            </Cell>
          </Column>

          <Column width={160}>
            <HeaderCell>ผู้ดำเนินการ</HeaderCell>
            <Cell dataKey="actionName" />
          </Column>

          <Column width={200}>
            <HeaderCell>เจ้าหน้าที่พัสดุ</HeaderCell>
            <Cell dataKey="reviewerName" />
          </Column>

          <Column width={160}>
            <HeaderCell>วันที่ขอขึ้นทะเบียน/ปิดครุภัณฑ์</HeaderCell>
            <Cell dataKey="requestDate" />
          </Column>

          <Column width={160}>
            <HeaderCell>วันที่ให้ความเห็น</HeaderCell>
            <Cell dataKey="reviewDate" />
          </Column>

          <Column width={300}>
            <HeaderCell>ความเห็น</HeaderCell>
            <Cell dataKey="message" />
          </Column>

          <Column width={120} align="center" fixed="right">
            <HeaderCell>จัดการรายการ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <SaveButton
                    icon="eye"
                    onClick={() => {
                      onSelect(rowData)
                    }}
                  >
                    แสดง
                  </SaveButton>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </div>
    </>
  )
}
